import { lazy, Suspense, useEffect } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { useLang } from '@/stores/lang';
import { HTML_LANG } from '@/i18n';
import { GoogleTagManager } from '@/components/GoogleTagManager';
import Landing from '@/pages/Landing';

const Sesiones = lazy(() => import('@/pages/Sesiones'));
const Ubicacion = lazy(() => import('@/pages/Ubicacion'));
const Menu = lazy(() => import('@/pages/Menu'));
const Pago = lazy(() => import('@/pages/Pago'));
const Confirmacion = lazy(() => import('@/pages/Confirmacion'));
const Pagar = lazy(() => import('@/pages/Pagar'));
const Encuesta = lazy(() => import('@/pages/Encuesta'));
const TicketPreview = lazy(() => import('@/pages/TicketPreview'));
const Cancelar = lazy(() => import('@/pages/Cancelar'));
const Gestionar = lazy(() => import('@/pages/Gestionar'));
const ModificarSesion = lazy(() => import('@/pages/ModificarSesion'));
const ModificarMenu = lazy(() => import('@/pages/ModificarMenu'));
const AnadirAsistentes = lazy(() => import('@/pages/AnadirAsistentes'));
const PoliticaCancelacion = lazy(() => import('@/pages/PoliticaCancelacion'));
const AdminLogin = lazy(() => import('@/pages/AdminLogin'));
const AdminDashboard = lazy(() => import('@/pages/AdminDashboard'));
const AdminSurveys = lazy(() => import('@/pages/AdminSurveys'));
const AdminEvents = lazy(() => import('@/pages/AdminEvents'));
const AdminTables = lazy(() => import('@/pages/AdminTables'));
const AdminTiers = lazy(() => import('@/pages/AdminTiers'));
const AdminMenus = lazy(() => import('@/pages/AdminMenus'));
const AdminCancellationPolicy = lazy(
  () => import('@/pages/AdminCancellationPolicy')
);
const AdminUsers = lazy(() => import('@/pages/AdminUsers'));
const AdminAudit = lazy(() => import('@/pages/AdminAudit'));

function App() {
  const lang = useLang((s) => s.lang);
  useEffect(() => {
    document.documentElement.lang = HTML_LANG[lang];
  }, [lang]);
  return (
    <BrowserRouter>
      <GoogleTagManager />
      <Suspense
        fallback={
          <div className="min-h-screen bg-ink text-ink-muted flex items-center justify-center">
            Cargando…
          </div>
        }
      >
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/sesiones" element={<Sesiones />} />
          <Route path="/ubicacion" element={<Ubicacion />} />
          <Route path="/menu" element={<Menu />} />
          <Route path="/pago" element={<Pago />} />
          <Route path="/politica-cancelacion" element={<PoliticaCancelacion />} />
          <Route path="/confirmacion/:reservationId" element={<Confirmacion />} />
          <Route path="/pagar/:reservationId" element={<Pagar />} />
          <Route path="/encuesta/:token" element={<Encuesta />} />
          <Route path="/ticket" element={<TicketPreview />} />
          <Route path="/ticket/:reservationId" element={<TicketPreview />} />
          <Route path="/cancelar/:reservationId" element={<Cancelar />} />
          <Route path="/gestionar/:reservationId" element={<Gestionar />} />
          <Route
            path="/gestionar/:reservationId/sesion"
            element={<ModificarSesion />}
          />
          <Route
            path="/gestionar/:reservationId/menu"
            element={<ModificarMenu />}
          />
          <Route
            path="/gestionar/:reservationId/asistentes"
            element={<AnadirAsistentes />}
          />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/encuestas" element={<AdminSurveys />} />
          <Route path="/admin/eventos" element={<AdminEvents />} />
          <Route path="/admin/mesas" element={<AdminTables />} />
          <Route path="/admin/precios" element={<AdminTiers />} />
          <Route path="/admin/menus" element={<AdminMenus />} />
          <Route
            path="/admin/politica"
            element={<AdminCancellationPolicy />}
          />
          <Route path="/admin/usuarios" element={<AdminUsers />} />
          <Route path="/admin/auditoria" element={<AdminAudit />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
